import Brands from '@/components/brands/Brands'
import BrandsNew from '@/components/brands/BrandsNew'
import BrandsEdit from '@/components/brands/BrandsEdit'
export default [
  {
    path: '/brands',
    name: 'brands',
    component: Brands,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/brands/new',
    name: 'brandsNew',
    component: BrandsNew,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/brands/:id/edit',
    name: 'brandsEdit',
    component: BrandsEdit,
    meta: {
      requiresAuth: true
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/brandsRoutes.js